import { ITimezone } from '@framework/timezone/vo/Timezone';
import DateTime from '@dealroadshow/uikit-date-time';

export function getTimeZoneDisplayNameDate(timeZone: ITimezone) {
  return new DateTime({ timeZone }).getTimeZoneDisplayName();
}

export function getTimeZoneById(timeZones: ITimezone[], id: string) {
  return timeZones.find((timeZone) => timeZone.id === id);
}

export function getDefaultTimeZone(timeZones: ITimezone[]) {
  return timeZones.find((timeZone) => !!timeZone.default);
}

export const guessTimeZone = (timeZones: ITimezone[]) => {
  return (
    timeZones.find((timeZone) => timeZone.timeZone === Intl.DateTimeFormat().resolvedOptions().timeZone) ??
    getDefaultTimeZone(timeZones)
  );
};

export interface ITimeZoneOption {
  value: string,
  label: string,
  timeZone: string,
}

export const getTimeZoneOption = (timeZone: ITimezone): ITimeZoneOption => ({
  value: timeZone.id,
  label: getTimeZoneDisplayNameDate(timeZone),
  timeZone: timeZone.timeZone,
});
